import React from "react";
import { Menu, MenuButton, MenuItem } from "@szhsin/react-menu";
import MoreVert from "@mui/icons-material/MoreVert";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import DriveFileMoveIcon from "@mui/icons-material/DriveFileMove";
import PublicOutlinedIcon from "@mui/icons-material/PublicOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { ReactComponent as SettingsIcon } from "@assets/icons/wheelMenuIcons/Setting.svg";

import { colors } from "../../../utils";

const FoldersThreeDotMenu = ({
  folder,
  onSettingsClick,
  onMoveClick,
  onVisibilityChange,
  onDeleteClick,
}) => {
  const handleMenuAction = (action) => {
    switch (action) {
      case "settings":
        onSettingsClick?.(folder);
        break;
      case "move":
        onMoveClick?.(folder);
        break;
      case "visibility":
        onVisibilityChange?.(folder);
        break;
      case "delete":
        onDeleteClick?.(folder);
        break;
      default:
        break;
    }
  };

  const iconStyles = {
    fontSize: 16,
    color: colors.lightGrey,
  };

  const menuItems = [
    {
      action: "settings",
      label: "Settings",
      icon: <SettingsIcon style={{ height: 16, width: 16 }} />,
      style: {
        color: colors.textBlue,
      },
    },
    {
      action: "move",
      label: "Move to folder",
      icon: (
        <DriveFileMoveIcon
          style={iconStyles}
          sx={{ color: "#C283DA !important" }}
        />
      ),
      style: {
        color: colors.textBlue,
      },
    },
    {
      action: "visibility",
      label:
        folder?.visibility === 1 ? "Change to Private" : "Change to Public",
      icon:
        folder?.visibility === 1 ? (
          <PublicOutlinedIcon style={iconStyles} />
        ) : (
          <LockOutlinedIcon style={iconStyles} />
        ),
      style: {
        color: colors.textBlue,
      },
    },
    {
      action: "delete",
      label: "Delete",
      icon: (
        <DeleteOutlineOutlinedIcon
          style={iconStyles}
          sx={{ color: "#E54D2E !important" }}
        />
      ),
      style: {
        color: colors.textBlue,
      },
    },
  ];

  // separate delete to bottom like WheelCardThreeDotMenu
  const bottomKeys = ["delete"];
  const topMenuItems = menuItems.filter(
    (it) => !bottomKeys.includes(it.action)
  );
  const bottomMenuItems = menuItems.filter((it) =>
    bottomKeys.includes(it.action)
  );

  return (
    <Menu
      portal={true}
      viewScroll="close"
      direction="bottom"
      menuButton={
        <MenuButton
          style={{
            backgroundColor: "transparent",
            border: "none",
            cursor: "pointer",
            width: 20,
            color: colors.darkGrey,
          }}
        >
          <MoreVert fontSize="small" />
        </MenuButton>
      }
      menuStyle={{
        border: "1px solid #ddd",
        borderRadius: "8px",
        padding: "8px",
        zIndex: 9999,
        background: "white",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
        width: "200px",
      }}
    >
      {topMenuItems.map((item, index) => (
        <MenuItem
          key={`${item.action}-${index}`}
          onClick={() => handleMenuAction(item.action)}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            padding: "10px",
            cursor: "pointer",
            fontSize: "14px",
            fontFamily: "DM Sans, sans-serif",
            borderRadius: "6px",
            ...item.style,
          }}
        >
          {item.icon} {item.label}
        </MenuItem>
      ))}

      {bottomMenuItems.length > 0 && (
        <>
          <div style={{ height: 1, background: "#F7F2FA", margin: "6px 0" }} />
          {bottomMenuItems.map((item, index) => (
            <MenuItem
              key={`${item.action}-bottom-${index}`}
              onClick={() => handleMenuAction(item.action)}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                padding: "10px",
                cursor: "pointer",
                fontSize: "14px",
                fontFamily: "DM Sans, sans-serif",
                borderRadius: "6px",
                ...item.style,
              }}
            >
              {item.icon} {item.label}
            </MenuItem>
          ))}
        </>
      )}
    </Menu>
  );
};

export default FoldersThreeDotMenu;
